<template>
  <div>
    <v-chip
      class="ml-2"
      v-for="(elem, index) in rules"
      :key="index"
      close
      small
      :color="elem.ruleType ? 'green' : 'red'"
      @click:close="removeRuleByName(elem.name)"
      >{{ elem.name }}
    </v-chip>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  methods: {
    removeRuleByName(name) {
      console.log(name);
      this.$store.dispatch("rules/removeRuleByName", name);
      this.$emit("rulesUpdated");
      this.$emit("removedRule", name);
    }
  },
  computed: {
    ...mapGetters({
      rules: "rules/rules"
    }),
    console: () => console
  }
};
</script>

<style></style>
